import { CalendarEventReminder, ReminderChannel } from "@/models/calendar-event-reminder";

export class CalendarSettings {
	OpenedCalendarIDs = [] as number[];
	OpenedGoogleCalendarIDs = [] as string[];
	OpenedTaskFolderIDs = [] as number[];
	WidgetCalendarIDs = [] as number[];
	WidgetGoogleCalendarIDs = [] as string[];
	DefaultEventDuration:number = 1;
	FirstDayOfWeek:number = 0;
	DefaultReminders:CalendarEventReminder[] = [];
	SaleEventGetColorMethod:string = "";
	SaleEventLinkToDeliveryDate:boolean = true;

	constructor(data:any) {
		this.OpenedCalendarIDs = data.OpenedCalendarIDs;
		this.OpenedGoogleCalendarIDs = data.OpenedGoogleCalendarIDs;
		this.OpenedTaskFolderIDs = data.OpenedTaskFolderIDs || [];
		this.WidgetCalendarIDs = data.WidgetCalendarIDs || [];
		this.WidgetGoogleCalendarIDs = data.WidgetGoogleCalendarIDs || [];
		this.DefaultEventDuration = data.DefaultEventDuration || 1;
		this.FirstDayOfWeek = data.FirstDayOfWeek || 0;
		this.SaleEventGetColorMethod = data.SaleEventGetColorMethod || "";
		this.SaleEventLinkToDeliveryDate = data.SaleEventLinkToDeliveryDate !== false;
		if (Array.isArray(data.DefaultReminders)) {
			this.DefaultReminders = data.DefaultReminders.map((r:any) => new CalendarEventReminder(r));
		} else {
			let reminder = new CalendarEventReminder();
			reminder.MinutesBefore = 30;
			reminder.Channel = ReminderChannel.APP;
			this.DefaultReminders = [reminder];
		}
	}

	getJSON() {
		return {
			OpenedCalendarIDs: this.OpenedCalendarIDs,
			OpenedGoogleCalendarIDs: this.OpenedGoogleCalendarIDs,
			OpenedTaskFolderIDs: this.OpenedTaskFolderIDs,
			WidgetCalendarIDs: this.WidgetCalendarIDs,
			WidgetGoogleCalendarIDs: this.WidgetGoogleCalendarIDs,
			DefaultEventDuration: this.DefaultEventDuration,
			FirstDayOfWeek: this.FirstDayOfWeek,
			SaleEventGetColorMethod: this.SaleEventGetColorMethod,
			SaleEventLinkToDeliveryDate: this.SaleEventLinkToDeliveryDate,
			DefaultReminders: this.DefaultReminders.map(r => ({MinutesBefore: r.MinutesBefore, Channel: r.Channel}))
		};
	}
}